import { render, staticRenderFns } from "./ReporteLiquidacionesDirectas.vue?vue&type=template&id=024679aa&scoped=true"
import script from "./ReporteLiquidacionesDirectas.vue?vue&type=script&lang=js"
export * from "./ReporteLiquidacionesDirectas.vue?vue&type=script&lang=js"
import style0 from "./ReporteLiquidacionesDirectas.vue?vue&type=style&index=0&id=024679aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024679aa",
  null
  
)

export default component.exports